export default __webpack_public_path__ + "static/media/honey-bottle-svg.48c6efa0.svg";